export default __webpack_public_path__ + "static/mosaic-cursor-do-light-6448ff9bd72da255f8504c3a36af7cf9.png";